//#region IMPORT
import React, { useState, useEffect } from 'react';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { NOT_BASIC_01_02 } from './index';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { Loading } from '../../../../Components/MUIs';
import useFileUpload from '../../../../hooks/useFileUpload';
import {
  useDelete1,
  useSave1,
  useSave2,
  useSearch1Run,
  useSearch2,
  useSearch3,
} from './NOT_BASIC_01_02_QUERY';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import { NOT_BASIC_01_02_Schema } from './NOT_BASIC_01_02_Schema';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import useFcmHandler from '../../../../hooks/useFcmHandler';
//#endregion

//#region 상수
const SCREEN_MENU_ID = 'Notice2';
const NOT_BASIC_01_02_FCM_GUBUN_NEW = 'AL_003_001';
const NOT_BASIC_01_02_FCM_GUBUN_UPDATE = 'AL_003_002';
const FCM_BULK_CHUNK = 100;
//#endregion

const normalizeGubunDtlArr = (gubunDtl) => {
  if (gubunDtl == null || gubunDtl === '') return [];
  const arr = Array.isArray(gubunDtl) ? gubunDtl : String(gubunDtl).split(',');
  return arr.filter((v) => v !== '' && v != null);
};

/** 저장 API와 동일한 공지 payload (FCM 대상 산출용) */
const buildNoticeSaveInput = ({
  inputs,
  userInfo,
  selectedCo,
  selectedCustForDept,
  companyInfo,
}) => {
  let finalInput = { ...inputs };

  if (
    userInfo?.authCd !== 'BUSINESS_OWNER' &&
    userInfo?.authCd !== 'ADMIN' &&
    userInfo?.authCd !== 'HEAD_MANAGER'
  ) {
    finalInput.gubun = '1';
    finalInput.gubunDtl = [userInfo?.custCd];
    finalInput.gubunDtlNm = [userInfo?.custNm];
  }

  if (String(finalInput.gubun) === '0') {
    if (userInfo.authCd === 'HEAD_MANAGER') {
      finalInput.gubun = '1';
      finalInput.gubunDtl = [userInfo.custCd].filter(Boolean);
      finalInput.gubunDtlNm = [userInfo.custNm || userInfo.custCd || ''];
    } else if (userInfo.authCd === 'BUSINESS_OWNER') {
      const coCd = userInfo.coCd || '';
      const coNm = (companyInfo || []).find((c) => c.coCd === coCd)?.coNm || '';
      finalInput.gubun = '3';
      finalInput.gubunDtl = coCd ? [coCd] : [];
      finalInput.gubunDtlNm = coCd ? [coNm || coCd] : [];
    } else if (userInfo.authCd === 'ADMIN') {
      const adminCo =
        typeof selectedCo === 'object' ? selectedCo?.coCd : selectedCo;
      if (adminCo) {
        const coNm =
          (companyInfo || []).find((c) => c.coCd === String(adminCo))?.coNm ||
          String(adminCo);
        finalInput.gubun = '3';
        finalInput.gubunDtl = [adminCo];
        finalInput.gubunDtlNm = [coNm];
        finalInput.coCd = adminCo;
      } else {
        finalInput.gubun = '0';
        finalInput.gubunDtl = '';
        finalInput.gubunDtlNm = '';
      }
    }
  }

  if (userInfo.authCd === 'ADMIN') {
    const g = String(finalInput.gubun ?? '');
    if (['1', '2', '3'].includes(g)) {
      const adminCo =
        typeof selectedCo === 'object' ? selectedCo?.coCd : selectedCo;
      if (adminCo) finalInput.coCd = adminCo;
    }
  }

  if (String(finalInput.gubun) === '2') {
    finalInput.custCd =
      selectedCustForDept ||
      (userInfo.authCd === 'HEAD_MANAGER' ? userInfo.custCd : '') ||
      '';
  } else {
    finalInput.custCd = '';
  }

  return finalInput;
};

const resolveNoticeCoCd = (finalInput, userInfo, selectedCo) => {
  if (userInfo?.authCd === 'ADMIN') {
    return (
      finalInput.coCd ||
      (typeof selectedCo === 'object' ? selectedCo?.coCd : selectedCo) ||
      userInfo.coCd ||
      ''
    );
  }
  return userInfo?.coCd || '';
};

const fetchMembersForNoticeFcm = async ({ userInfo, coCd, custCd }) => {
  const params = {
    UserId: userInfo?.userid,
    AuthCd: Commons.EncryptAES(userInfo?.authCd || ''),
    CoCd: Commons.EncryptAES(coCd || ''),
    CustCd: Commons.EncryptAES(custCd || ''),
    SearchText: Commons.EncryptAES(''),
  };
  const data = await apiRequest(
    'post',
    Global.urls.Member.getMemBasicR1,
    params
  );
  return Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : [];
};

const collectActiveMemberIds = (rows, requesterId, idSet) => {
  (rows || []).forEach((m) => {
    const useYn = String(m.useYn ?? m.UseYn ?? 'Y').toUpperCase();
    if (useYn !== 'Y') return;
    const id = String(m.id ?? m.ID ?? m.userId ?? '').trim();
    if (id && id !== requesterId) idSet.add(id);
  });
};

const resolveNoticeRecipientUserIds = async ({
  finalInput,
  userInfo,
  selectedCo,
  custInfo,
  search1SitesAsync,
}) => {
  const coCd = resolveNoticeCoCd(finalInput, userInfo, selectedCo);
  const gubun = String(finalInput.gubun ?? '');
  const gubunDtl = normalizeGubunDtlArr(finalInput.gubunDtl);
  const requesterId = String(userInfo?.userid || '').trim();
  const idSet = new Set();

  if (gubun === '1') {
    const custCds =
      gubunDtl.length > 0 ? gubunDtl : [userInfo?.custCd].filter(Boolean);
    for (const custCd of custCds) {
      const rows = await fetchMembersForNoticeFcm({ userInfo, coCd, custCd });
      collectActiveMemberIds(rows, requesterId, idSet);
    }
    return [...idSet];
  }

  if (gubun === '2') {
    const custCd = finalInput.custCd || userInfo?.custCd || '';
    if (!custCd) return [];
    const depSet = new Set(gubunDtl.map(String));
    const rows = await fetchMembersForNoticeFcm({ userInfo, coCd, custCd });
    rows.forEach((m) => {
      const depCd = String(m.depCd ?? m.DepCd ?? '').trim();
      if (!depSet.has(depCd)) return;
      collectActiveMemberIds([m], requesterId, idSet);
    });
    return [...idSet];
  }

  if (gubun === '3' || gubun === '0') {
    let siteRows = (custInfo || []).map((c) => ({
      custCd: c.custCd,
      custNm: c.custNm,
    }));
    if (userInfo?.authCd === 'ADMIN' && coCd && search1SitesAsync) {
      try {
        const companyRows = await search1SitesAsync({ search: { coCd } });
        siteRows = sitesFromCompanyInfoRows(companyRows);
      } catch (e) {
        console.error('[NOT_BASIC_01_02] 사업장 목록 조회 실패:', e);
      }
    }
    if (!siteRows.length && userInfo?.custCd) {
      siteRows = [{ custCd: userInfo.custCd }];
    }
    for (const site of siteRows) {
      const custCd = site?.custCd || site?.value;
      if (!custCd) continue;
      const rows = await fetchMembersForNoticeFcm({ userInfo, coCd, custCd });
      collectActiveMemberIds(rows, requesterId, idSet);
    }
  }

  return [...idSet];
};

const SendNoticeFcmByTarget = async ({
  sendFcm,
  finalInput,
  savedRow,
  changeRow,
  userInfo,
  selectedCo,
  custInfo,
  search1SitesAsync,
  dispatch,
}) => {
  if (!sendFcm?.bulk) return;

  const saved = savedRow || {};
  const isSuccess = saved.isSuccess === true || saved.IsSuccess === true;
  if (!isSuccess) return;

  let targetUserIds = [];
  try {
    targetUserIds = await resolveNoticeRecipientUserIds({
      finalInput,
      userInfo,
      selectedCo,
      custInfo,
      search1SitesAsync,
    });
  } catch (e) {
    console.error('[NOT_BASIC_01_02] 수신자 조회 실패:', e);
    return;
  }

  if (!targetUserIds.length) {
    dispatch(
      showSnackbar({
        message: '알림을 보낼 대상 인력이 없습니다.',
        type: 'info',
      })
    );
    return;
  }

  const chaebunNo =
    saved.chaebunNo ??
    saved.ChaebunNo ??
    changeRow?.chaebunNo ??
    finalInput.chaebunNo ??
    '';
  const noticeTitle = String(finalInput.title ?? changeRow?.title ?? '').trim();
  const isUpdate = Boolean(
    String(changeRow?.chaebunNo ?? finalInput.chaebunNo ?? '').trim()
  );
  const codeGroup = isUpdate
    ? NOT_BASIC_01_02_FCM_GUBUN_UPDATE
    : NOT_BASIC_01_02_FCM_GUBUN_NEW;
  const body =
    noticeTitle ||
    (isUpdate ? '공지 내용이 수정되었습니다.' : '공지가 등록되었습니다.');

  try {
    await sendFcm.bulk({
      targetUserIds,
      title: isUpdate ? '공지사항 수정' : '공지사항',
      body,
      codeGroup,
      route: chaebunNo ? `/M_Notice/detail/${chaebunNo}` : '/M_Notice',
      responseData: String(chaebunNo),
      chunkSize: FCM_BULK_CHUNK,
    });
  } catch (e) {
    console.error('[NOT_BASIC_01_02] FCM 전송 오류:', e);
    dispatch(
      showSnackbar({
        message: e?.message || '공지 알림 전송에 실패했습니다.',
        type: 'warning',
      })
    );
  }
};

/** GetCompanyInfo: `data[0].custList`가 사업장 배열. 구형(flat custCd 행) 응답도 허용 */
const sitesFromCompanyInfoRows = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return [];
  const first = list[0];
  if (Array.isArray(first?.custList)) return first.custList;
  if (first?.custCd != null || first?.custNm != null) return list;
  return [];
};

function NOT_BASIC_01_02F() {
  //#region 변수
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dateValue, setDateValue] = useState(dayjs().format('YYYY-MM-DD'));
  const dispatch = useDispatch();
  const sendFcm = useFcmHandler();
  const { userInfo, companyInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );

  const [comboData, setComboData] = useState([
    { value: '0', name: '전체' },
    { value: '1', name: '사업장' },
    { value: '2', name: '부서' },
  ]);
  const [gubunDtlData, setGubunDtlData] = useState(
    custInfo.map((item) => ({
      value: item.custCd,
      label: item.custNm,
    }))
  );
  /** 부서 구분 시 사업장 선택(ADMIN·BUSINESS_OWNER) */
  const [custListForDept, setCustListForDept] = useState([]);
  const [selectedCustForDept, setSelectedCustForDept] = useState('');
  const [selectedGjs, setSelectedGjs] = useState([]);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [inputs, setInputs] = useState({
    coCd: '',
    chaebunNo: '',
    title: '',
    comment: '',
    gubun: '0',
    gubunDtl: '',
    gubunDtlNm: '',
    custCd: '',
    endDate: dayjs().format('YYYY-MM-DD'),
    noticeYn: 'N',
    noticeType: '0',
  });
  const [codeList, setCodeList] = useState([]);
  const [dialogToggle1, setDialogToggle1] = useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });

  const [coList, setCoList] = useState(
    (companyInfo || []).map((c) => ({ value: c.coCd, name: c.coNm }))
  );
  const [selectedCo, setSelectedCo] = useState(
    companyInfo.length > 0 ? companyInfo[0].coCd : ''
  );

  const isDeptSiteRequired =
    inputs.gubun === '2' &&
    ['ADMIN', 'BUSINESS_OWNER'].includes(userInfo?.authCd);
  const isDisabled =
    inputs.gubun === '0' ||
    gubunDtlData.length === 0 ||
    (isDeptSiteRequired && !selectedCustForDept);
  const [noticeChecked, setNoticeChecked] = useState(true);

  //파일 업로드 훅
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (item, chaebunNo) => {
      const coCd = userInfo.authCd === 'ADMIN' ? selectedCo : userInfo.coCd;
      return `NoticeBoard/${coCd}/NOT_BASIC_01_02/${chaebunNo || inputs.chaebunNo || ''}`;
    },
  });
  //#endregion

  //#region 쿼리
  const { runAsync: Search1SitesAsync } = useSearch1Run();

  // 파일 목록 조회
  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      const mappedRows = rows.map((f) => ({
        ...f,
        preview: /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
          ? `${Global.base.fileUrl}/${f.filePath}`
          : null,
        deleted: false,
      }));
      setUploadedFiles(mappedRows);
    },
  });

  /** depNm1만 있고 하위명이 없는 행만, 동일 depNm1은 한 건만(선택 혼선 방지) */
  const filterDeptRowsForNotice = (rows) => {
    const raw = rows || [];
    const onlyNm1 = raw.filter((item) => {
      const n1 = (item.depNm1 || '').trim();
      if (!n1) return false;
      const n2 = (item.depNm2 || '').trim();
      const n3 = (item.depNm3 || '').trim();
      const n4 = (item.depNm4 || '').trim();
      return !n2 && !n3 && !n4;
    });
    const seen = new Set();
    const deduped = [];
    for (const item of onlyNm1) {
      const key = (item.depNm1 || '').trim();
      if (seen.has(key)) continue;
      seen.add(key);
      deduped.push(item);
    }
    return deduped;
  };

  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      const filtered = filterDeptRowsForNotice(rows);
      const list = filtered.map((item, idx) => ({
        value: item.depCd,
        label: (item.depNm1 || '').trim() || `부서 ${idx + 1}`,
      }));
      setGubunDtlData(list);
    },
  });

  const loadDepartments = async (custCd) => {
    if (!custCd) {
      setGubunDtlData([]);
      return;
    }
    const search = { custCd };
    if (userInfo.authCd === 'ADMIN') {
      const co = typeof selectedCo === 'object' ? selectedCo?.coCd : selectedCo;
      search.coCd = co;
    }
    await Search3Async({ search });
  };

  useEffect(() => {
    if (userInfo?.authCd === 'HEAD_MANAGER') {
      setComboData([
        { value: '0', name: '전체' },
        { value: '2', name: '부서' },
      ]);
    } else {
      setComboData([
        { value: '0', name: '전체' },
        { value: '1', name: '사업장' },
        { value: '2', name: '부서' },
      ]);
    }
  }, [userInfo?.authCd]);

  useEffect(() => {
    if (state?.data) {
      setNoticeChecked(state.data.noticeYn === 'Y');
      setSelectedCo(state.data.coCd);
      /** DB에 구분 3(회사 단위)으로 저장된 ADMIN 공지는 화면에서만 구분 0(선택 회사 전체)으로 본다 */
      const isAdminSavedAsCompanyWide =
        userInfo?.authCd === 'ADMIN' && String(state.data.gubun) === '3';
      const formData = isAdminSavedAsCompanyWide
        ? {
            ...state.data,
            gubun: '0',
            gubunDtl: '',
            gubunDtlNm: '',
          }
        : state.data;
      const newValue =
        typeof formData.gubunDtl === 'string'
          ? formData.gubunDtl.split(',')
          : formData.gubunDtl;
      setInputs({
        ...formData,
        noticeType: String(
          formData.noticeType ?? formData.NOTICE_TYPE ?? '0'
        ),
      });
      setSelectedGjs(
        isAdminSavedAsCompanyWide ? [] : newValue[0] !== '' ? newValue : []
      );
    } else {
      setInputs({
        coCd: '',
        chaebunNo: '',
        title: '',
        comment: '',
        gubun: '0',
        gubunDtl: '',
        gubunDtlNm: '',
        custCd: '',
        endDate: dayjs().format('YYYY-MM-DD'),
        noticeYn: 'N',
        noticeType: '0',
        createId: userInfo.userid,
      });
      setNoticeChecked(true);
      setSelectedGjs([]);
      setCustListForDept([]);
      setSelectedCustForDept('');
    }
    if (state?.coCd) setSelectedCo(state.coCd);
  }, [state, userInfo.userid, userInfo?.authCd]);

  const Init = async () => {
    if (!state?.data) return;
    setLoading(true);
    try {
      await Search2({
        chaebunNo: state?.data?.chaebunNo,
      });
      if (state.data.gubun === '1') {
        if (userInfo.authCd === 'ADMIN') {
          const coCd = state.data.coCd || selectedCo;
          const rows = await Search1SitesAsync({ search: { coCd } });
          const siteRows = sitesFromCompanyInfoRows(rows);
          if (!siteRows.length) {
            dispatch(
              showSnackbar({
                message: '해당 회사에 사업장 정보가 비어있습니다.',
                type: 'error',
              })
            );
            setGubunDtlData([]);
          } else {
            setGubunDtlData(
              siteRows.map((item) => ({
                value: item.custCd,
                label: item.custNm,
              }))
            );
          }
        } else {
          setGubunDtlData(
            custInfo.map((item) => ({
              value: item.custCd,
              label: item.custNm,
            }))
          );
        }
        const gv = normalizeGubunDtlArr(state.data.gubunDtl);
        setSelectedGjs(gv.length ? gv : []);
      } else if (state.data.gubun === '2') {
        const gv = normalizeGubunDtlArr(state.data.gubunDtl);
        const coCd = state.data.coCd || selectedCo;
        let custCd = state.data.custCd;
        if (
          !custCd &&
          ['HEAD_MANAGER', 'BUSINESS_OWNER'].includes(userInfo.authCd)
        ) {
          custCd = userInfo.custCd;
        }
        let sites = null;
        if (!custCd && userInfo.authCd === 'ADMIN') {
          const companyRows = await Search1SitesAsync({ search: { coCd } });
          sites = sitesFromCompanyInfoRows(companyRows);
          const depIds = gv;
          if (sites?.length && depIds.length) {
            for (const s of sites) {
              const deps = await Search3Async({
                search: { custCd: s.custCd, coCd },
              });
              const depSet = new Set((deps || []).map((d) => d.depCd));
              if (depIds.every((id) => depSet.has(id))) {
                custCd = s.custCd;
                break;
              }
            }
            if (!custCd) custCd = sites[0].custCd;
          }
        }
        if (userInfo.authCd === 'BUSINESS_OWNER') {
          setCustListForDept(
            custInfo.map((item) => ({
              value: item.custCd,
              name: item.custNm,
            }))
          );
        } else if (userInfo.authCd === 'ADMIN') {
          if (!sites) {
            const companyRows = await Search1SitesAsync({ search: { coCd } });
            sites = sitesFromCompanyInfoRows(companyRows);
          }
          setCustListForDept(
            (sites || []).map((item) => ({
              value: item.custCd,
              name: item.custNm,
            }))
          );
        } else {
          setCustListForDept([]);
        }
        setSelectedCustForDept(custCd || '');
        if (custCd) {
          const search = { custCd };
          if (userInfo.authCd === 'ADMIN') search.coCd = coCd;
          await Search3Async({ search });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.authCd, userInfo.custCd, custInfo, state?.data?.chaebunNo]);

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    deleteMutation: delete1,
    deletedRowData: uploadedFiles.filter((item) => item.deleted),
  });

  // 저장
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '제목, 내용',
    schema: NOT_BASIC_01_02_Schema,
    getChangedRows: () =>
      Commons.Deduplication([
        buildNoticeSaveInput({
          inputs,
          userInfo,
          selectedCo,
          selectedCustForDept,
          companyInfo,
        }),
      ]),
    getDeletedRows: () => uploadedFiles.filter((item) => item.deleted),
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    afterSaveRow: async (
      item,
      { index, savedRows, userInfo: saveUserInfo }
    ) => {
      const finalInput = buildNoticeSaveInput({
        inputs,
        userInfo,
        selectedCo,
        selectedCustForDept,
        companyInfo,
      });
      const coCd =
        saveUserInfo.authCd === 'ADMIN' ? selectedCo : saveUserInfo.coCd;

      for (const item of uploadedFiles) {
        const filePath = `NoticeBoard/${coCd}/NOT_BASIC_01_02/${savedRows[0].chaebunNo}/${item.saveName}`;

        if (item.deleted) {
          // 파일이 삭제된 경우 (deleted === true)
          DeleteLogicFile(item.filePath);
        } else {
          const result = await Save2Async([
            {
              chaebunNo: savedRows[0].chaebunNo,
              fileName: item.fileName,
              saveName: item.saveName,
              filePath: filePath,
            },
          ]);

          // 새 파일이 업로드된 경우
          if (item.previewFilePath) {
            SaveLogicFile(item, savedRows[0].chaebunNo || '');
          }
        }
      }
      navigate('/NoticeBoard', {
        state: {
          coCd:
            userInfo.authCd === 'ADMIN'
              ? typeof selectedCo === 'object'
                ? selectedCo.coCd
                : selectedCo || userInfo.companyCd
              : userInfo.coCd,
        },
      });

      void SendNoticeFcmByTarget({
        sendFcm,
        finalInput,
        savedRow: savedRows?.[index] ?? savedRows?.[0],
        changeRow: item,
        userInfo: saveUserInfo,
        selectedCo,
        custInfo,
        search1SitesAsync: Search1SitesAsync,
        dispatch,
      });
    },
  });
  //#endregion

  //#region 나머지 함수
  //#region 파일 관련 로직
  // 파일 선택 핸들러
  const FileChange = async (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    setLoading(true);
    try {
      for (const file of files) {
        const timestamp = dayjs().format('YYYYMMDDHHmmss');
        const saveName = `${timestamp}_${file.name}`;
        const fileToSave = new File([file], saveName, { type: file.type });

        // 미리보기 업로드 (useFileUpload 훅 사용)
        const previewPath = await SaveLogicPreview(fileToSave);
        if (!previewPath) continue;

        const previewUrl = Global.file.useUrl + 'files/' + previewPath;

        setUploadedFiles((prev) => [
          ...prev,
          {
            fileId: '', // 신규는 빈값
            fileName: file.name, // 원본 파일명
            saveName: saveName, // 타임스탬프 포함
            fileType: file.type,
            preview: previewUrl,
            previewFilePath: previewPath,
          },
        ]);
      }
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: '파일 업로드 실패', type: 'error' }));
    } finally {
      setLoading(false);
      event.target.value = '';
    }
  };

  const DeletePreview = async (fileItem) => {
    try {
      setUploadedFiles((prev) =>
        prev.map((img) => (img === fileItem ? { ...img, deleted: true } : img))
      );
    } catch (e) {
      console.error('❌ DeletePreview Error:', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };
  //#endregion

  //#region 회사/구분/상세 처리
  const handleCoChange = async (newCoCd) => {
    setSelectedCo(newCoCd);
    setGubunDtlData([]);
    setSelectedGjs([]);
    setCustListForDept([]);
    setSelectedCustForDept('');
    if (newCoCd === '') return;
    setInputs({
      ...inputs,
      gubun: '0',
      gubunDtl: '',
      gubunDtlNm: '',
    });
  };

  const handleDeptSiteChange = async (custCd) => {
    setSelectedCustForDept(custCd || '');
    setSelectedGjs([]);
    setInputs((prev) => ({
      ...prev,
      gubunDtl: '',
      gubunDtlNm: '',
    }));
    await loadDepartments(custCd);
  };

  const HandleGubunChange = async (newGubun) => {
    if (userInfo.authCd === 'ADMIN') {
      setSelectedGjs([]);
      setSelectedCustForDept('');
      setCustListForDept([]);
      setInputs((prev) => ({
        ...prev,
        gubun: newGubun,
        gubunDtl: '',
        gubunDtlNm: '',
      }));
      const coCd =
        typeof selectedCo === 'object' ? selectedCo?.coCd : selectedCo;
      if (!coCd) {
        setGubunDtlData([]);
        return;
      }
      if (newGubun === '0') {
        setGubunDtlData([]);
        return;
      }
      const rows = await Search1SitesAsync({ search: { coCd } });
      const siteRows = sitesFromCompanyInfoRows(rows);
      if (!siteRows.length) {
        dispatch(
          showSnackbar({
            message: '해당 회사에 사업장 정보가 비어있습니다.',
            type: 'error',
          })
        );
        setGubunDtlData([]);
        setCustListForDept([]);
        return;
      }
      if (newGubun === '1') {
        setGubunDtlData(
          siteRows.map((item) => ({
            value: item.custCd,
            label: item.custNm,
          }))
        );
        setCustListForDept([]);
      } else if (newGubun === '2') {
        setCustListForDept(
          siteRows.map((item) => ({
            value: item.custCd,
            name: item.custNm,
          }))
        );
        setGubunDtlData([]);
      }
    } else {
      if (newGubun === '0') {
        setGubunDtlData([]);
        setSelectedGjs([]);
        setCustListForDept([]);
        setSelectedCustForDept('');
      } else if (newGubun === '1') {
        setCustListForDept([]);
        setSelectedCustForDept('');
        setGubunDtlData(
          custInfo.map((item) => ({
            value: item.custCd,
            label: item.custNm,
          }))
        );
        setSelectedGjs([]);
      } else if (newGubun === '2') {
        setSelectedGjs([]);
        setInputs((prev) => ({
          ...prev,
          gubunDtl: '',
          gubunDtlNm: '',
        }));
        if (userInfo.authCd === 'HEAD_MANAGER') {
          setCustListForDept([]);
          setSelectedCustForDept(userInfo.custCd || '');
          await loadDepartments(userInfo.custCd);
        } else if (userInfo.authCd === 'BUSINESS_OWNER') {
          setCustListForDept(
            custInfo.map((item) => ({
              value: item.custCd,
              name: item.custNm,
            }))
          );
          setSelectedCustForDept('');
          setGubunDtlData([]);
        } else {
          setCustListForDept([]);
          setSelectedCustForDept('');
          setGubunDtlData([]);
        }
      }
    }
  };
  //#endregion

  const HandleGJChange = (e) => {
    const {
      target: { value },
    } = e;
    const newSelected = value
      .map((val) =>
        typeof val === 'string'
          ? gubunDtlData.find((item) => item.value === val)
          : val
      )
      .filter(Boolean);
    const label = newSelected.map((item) => item.label);
    const newValue = typeof value === 'string' ? value.split(',') : value;
    setSelectedGjs(newValue);
    setInputs((prev) => ({
      ...prev,
      gubunDtl: newValue,
      gubunDtlNm: label,
    }));
  };

  const HandleGJClick = () => {
    if (
      userInfo.authCd === 'ADMIN' &&
      inputs.gubun === '1' &&
      gubunDtlData.length === 0
    ) {
      dispatch(
        showSnackbar({
          message: '해당 회사에 사업장 정보가 비어있습니다.',
          type: 'error',
        })
      );
    }
    if (
      inputs.gubun === '2' &&
      ['ADMIN', 'BUSINESS_OWNER'].includes(userInfo.authCd) &&
      !selectedCustForDept
    ) {
      dispatch(
        showSnackbar({
          message: '부서를 불러오려면 먼저 사업장을 선택해주세요.',
          type: 'warning',
        })
      );
    }
  };

  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (!_data.fileId) {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  //#endregion

  return (
    <div className="wrap">
      <NOT_BASIC_01_02
        userInfo={userInfo}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        dateValue={dateValue}
        setDateValue={setDateValue}
        lanInfo={lanInfo}
        comboData={comboData}
        setComboData={setComboData}
        state={state}
        noticeChecked={noticeChecked}
        setNoticeChecked={setNoticeChecked}
        coList={coList}
        selectedCo={selectedCo}
        navigate={navigate}
        inputs={inputs}
        setInputs={setInputs}
        setCodeList={setCodeList}
        codeList={codeList}
        gubunDtlData={gubunDtlData}
        selectedGjs={selectedGjs}
        setSelectedGjs={setSelectedGjs}
        setGubunDtlData={setGubunDtlData}
        dialogToggle1={dialogToggle1}
        setDialogToggle1={setDialogToggle1}
        isDisabled={isDisabled}
        uploadedFiles={uploadedFiles}
        setUploadedFiles={setUploadedFiles}
        // 🔹 함수 props
        Save1={Save1}
        FileChange={FileChange}
        DeletePreview={DeletePreview}
        HandleGJChange={HandleGJChange}
        HandleGJClick={HandleGJClick}
        handleCoChange={handleCoChange}
        HandleGubunChange={HandleGubunChange}
        handleDeptSiteChange={handleDeptSiteChange}
        custListForDept={custListForDept}
        selectedCustForDept={selectedCustForDept}
        DownloadLogic2={DownloadLogic2}
      />
      <Loading open={loading} />
    </div>
  );
}

export default NOT_BASIC_01_02F;
